import { Grid, Typography } from '@material-ui/core'
import Image from 'next/legacy/image'
import styled from 'styled-components'
import { Button } from '../button/button'
import { irem } from '../../utils'
import { AltBg } from '../flexibleContent/fragments/altBg'

export const StyledImage = styled(Image)`
  position: relative;
  display: inline-block;
  width: 100%;
`

export const StyledTitle = styled(Typography)`
    margin-top: 0;
    font-size: ${props => props.theme.typography.pxToRem(20)};
    font-weight: 600;
    line-height: 1.4;
    text-align: left;
    max-height: ${props => props.theme.typography.pxToRem(190)};
    margin-bottom: 0;
    color: ${props => props.theme.palette.secondary.dark};

    ${props => props.theme.breakpoints.up('sm')} {
        font-size: ${props => props.theme.typography.pxToRem(32)};
        padding-top: 0;
        max-width: ${props => props.theme.typography.pxToRem(456)};
        line-height: ${props => props.theme.typography.pxToRem(45)};
    }
`

export const StyledDescription = styled(Typography)`
  display: block;
  padding-top: ${props => props.theme.typography.pxToRem(36)};

  ${props=> props.theme.breakpoints.up('md')} {
    display: -webkit-box;
    -webkit-line-clamp: none;
    -webkit-box-orient: vertical;
    font-size: ${props => props.theme.typography.pxToRem(17)};
    padding-top: ${props => props.theme.typography.pxToRem(41)};
    max-width: ${props => props.theme.typography.pxToRem(456)};
    line-height: ${props => props.theme.typography.pxToRem(35)};
  }

  p {
    margin-top: 0;
    margin-bottom: 0;
  }
`

export const StyleCta = styled(Button)`
  margin-top: ${props => props.theme.typography.pxToRem(36)};
  padding: 0.875rem 1.625rem;
  font-size: ${props => props.theme.typography.pxToRem(16)};

  ${props=> props.theme.breakpoints.up('md')} {
    margin-top: ${props => props.theme.typography.pxToRem(46)};
    padding: ${props => props.theme.typography.pxToRem(16)} ${props => props.theme.typography.pxToRem(30)};
    font-size: ${props => props.theme.typography.pxToRem(18)};
  }
`

export const StyledCarouselImageWrapper = styled(Grid)`
  width: 100%;
  aspect-ratio: 16/10;
  margin-top: 0 !important;
  overflow: hidden;
  border-radius: ${irem(12)} ${irem(12)} 0 0;

  ${props=> props.theme.breakpoints.up('md')} {
    border-radius: 0;
    padding-bottom: 0;
    width: ${props => props.theme.typography.pxToRem(798)};
    height: ${props => props.theme.typography.pxToRem(583)};
    margin-left: ${props => props.theme.typography.pxToRem(10)};
    margin-right: ${props => props.theme.typography.pxToRem(10)};
  }
`

export const StyledContentSection = styled(Grid)`
  position: relative;
  margin: auto;
  padding: ${irem(35)} ${irem(40)};
    
  ${props=> props.theme.breakpoints.up('md')} {
    padding: ${irem(83)};
  }
`

export const StyledOfferPromotionCarouselSection = styled(Grid)`
  width: 100%;
  position: relative;
`

export const StyledOfferPromotionCarouselContainer = styled.div<{$variant?: 'offer' | 'promotion'}>`
  position: relative;
  width: 100%;
  background: ${props => props.theme.custom.colors.grey};
  border-radius: ${irem(12)};
  margin-bottom: ${irem(50)};
    
  ${props=> props.theme.breakpoints.up('md')} {
    overflow: hidden;
    display: flex;
    align-items: stretch;
    flex-direction: ${props => props.$variant === 'offer' ? 'row' : 'row-reverse'};
    margin-bottom: 0;

    ${AltBg} & {
      background: white;
      border-radius: ${irem(12)};
    }
  }
`

export const StyledOfferPromotionCarouselWrapper = styled(Grid)`
  width: 100%;
  display: flex;
  flex-direction: column;

  ${props=> props.theme.breakpoints.up('md')} {
    gap: ${props => props.theme.typography.pxToRem(170)};
  }
`
